import { gql } from 'apollo-angular';

export const declareAllOperationsInGroup = gql`
  mutation declareAllOperationsInGroup($operationGroupId: Int!, $acknowledgeOutdatedDocuments: Boolean = false) {
    declareAllOperationsInGroup(
      operationGroupId: $operationGroupId
      acknowledgeOutdatedDocuments: $acknowledgeOutdatedDocuments
    ) {
      id
      operations {
        id
        statutId
        statut {
          id
          consultantLibelle
          backOfficeLibelle
        }
        activeOperationStateTransitionTriggers
      }
    }
  }
`;
